import { ConfigItem } from '@msdk/definitions'

import { ApiClient } from '../../api'
import { AsyncCache, NavigationHook } from '../../react'
import { UrlContext } from '../../state/url-context'
import { ComponentModal, DialogInputModal, DialogModal, FormModal, ViewModal } from '../modals'
import { CustomActionArgs } from './custom-action-args'

export abstract class CustomActionBase {
  protected readonly apiClient: ApiClient
  protected readonly formModal: FormModal
  protected readonly viewModal: ViewModal
  protected readonly componentModal: ComponentModal
  protected readonly dialogModal: DialogModal
  protected readonly dialogInputModal: DialogInputModal
  protected readonly translate: (idml: string, description: string) => string
  protected readonly asyncCache: AsyncCache
  protected readonly urlContext: UrlContext
  protected readonly config: ConfigItem[]
  protected readonly navigate: NavigationHook

  constructor(args: CustomActionArgs) {
    this.apiClient = args.apiClient
    this.formModal = args.modals.formModal
    this.viewModal = args.modals.viewModal
    this.componentModal = args.modals.componentModal
    this.dialogModal = args.modals.dialogModal
    this.dialogInputModal = args.modals.dialogInputModal
    this.translate = args.translate
    this.asyncCache = args.asyncCache
    this.urlContext = args.urlContext
    this.navigate = args.navigate
    this.config = args.config
  }

  public onInit(): Promise<void> {
    return Promise.resolve()
  }

  public abstract onClick(): void | Promise<void>

  public abstract isVisible(): boolean
  public abstract isDisabled(): boolean
}
